<!-- <public-nav></public-nav> -->

<router-outlet class="public-pages"></router-outlet>

<!--  *ngIf="!pagesToIgnoreFooter.includes(_router.url)" -->
<!-- <public-footer></public-footer> -->